import { render, staticRenderFns } from "./safe-space-carousel-card.vue?vue&type=template&id=9f3cbc50"
import script from "./safe-space-carousel-card.vue?vue&type=script&lang=js"
export * from "./safe-space-carousel-card.vue?vue&type=script&lang=js"
import style0 from "./safe-space-carousel-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports